<template>
    <div class="app-sidebar sidebar-shadow" @mouseover="toggleSidebarHover('add','closed-sidebar-open')"
         @mouseleave="toggleSidebarHover('remove','closed-sidebar-open')">
        <div class="app-header__logo">
            <div class="logo-src"/>
            <div class="header__pane ml-auto">
                <button type="button" class="hamburger close-sidebar-btn hamburger--elastic"
                        v-bind:class="{ 'is-active' : isOpen }" @click="toggleBodyClass('closed-sidebar')">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </button>
            </div>
        </div>
        <div class="app-sidebar-content">
            <VuePerfectScrollbar class="app-sidebar-scroll" v-once>
                <sidebar-menu showOneChild :menu="menu"/>
            </VuePerfectScrollbar>
        </div>

    </div>
</template>

<script>
import { SidebarMenu } from 'vue-sidebar-menu'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    SidebarMenu,
    VuePerfectScrollbar
  },
  data () {
    return {
      isOpen: false,
      sidebarActive: false,

      menu: [
        {
          header: true,
          title: 'Clients',
        },
        {
          title: 'Clients',
          icon: 'pe-7s-users',
          href: '/'
        },
        {
          title: 'Ajoute Client',
          icon: 'pe-7s-add-user',
          href: '/clients/add'
        },
        {
          header: true,
          title: 'A propos',
        },
        {
          title: 'A propos',
          icon: 'pe-7s-rocket',
          href: '/about'
        },
      ],
      collapsed: true,

      windowWidth: 0,

    }
  },
  props: {
    sidebarbg: String,
  },
  methods: {

    toggleBodyClass (className) {
      const el = document.body
      this.isOpen = !this.isOpen

      if (this.isOpen) {
        el.classList.add(className)
      } else {
        el.classList.remove(className)
      }
    },
    toggleSidebarHover (add, className) {
      const el = document.body
      this.sidebarActive = !this.sidebarActive

      this.windowWidth = document.documentElement.clientWidth

      if (this.windowWidth > '992') {
        if (add === 'add') {
          el.classList.add(className)
        } else {
          el.classList.remove(className)
        }
      }
    },
    getWindowWidth () {
      const el = document.body

      this.windowWidth = document.documentElement.clientWidth

      if (this.windowWidth < '1350') {
        el.classList.add('closed-sidebar', 'closed-sidebar-md')
      } else {
        el.classList.remove('closed-sidebar', 'closed-sidebar-md')
      }
    },
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)

      //Init
      this.getWindowWidth()
    })
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
  }
}
</script>

<style>
    .vsm-icon {
        color: black;
    }
    .closed-sidebar .app-sidebar .logo-src {
        width: 27px;
        margin: 0 auto;
    }
    .logo-src {
        height: 25px;
        width: 182px;
    }
</style>
